import styled from '@emotion/styled'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import Fab from '@mui/material/Fab'
import { colors } from '@global/constants'

export const FabContainer = styled(Fab)`
  height: 65px;
  width: 65px;
  color: ${colors.gray.light};
  cursor: auto;
`
export const FileCopyOutlinedIconContainer = styled(FileCopyOutlinedIcon)`
  font-size: 34px;
  color: ${colors.blue.smokey};
`
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const SearchContainer = styled.div`
  flex-shrink: 1px;
  margin-right: 12px;
`
export const SearchLoadingContainer = styled.div`
  padding: 24px;
  display: flex;
  width: 100%;
  justify-content: center;
`
export const TypographyContainer = styled.div`
  padding: 30px 24px 24px;
`
